import { createFileRoute, Navigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/hooks/useAuth";
import { CompanyListing } from "@/components/companies";

const companiesSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(50),
  search: z.string().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
  status: z.enum(["all", "active", "inactive"]).catch("all"),
});

export const Route = createFileRoute("/(protected)/_layout/_org/companies/")({
  validateSearch: (search) => companiesSearchSchema.parse(search),
  component: CompaniesTab,
});

function CompaniesTab() {
  const { isLoading, hasPermission } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!hasPermission("company:read")) {
    return (
      <Navigate
        to="/unauthorized"
        search={{
          reason: "permission_denied",
          from: "/companies",
          requiredPermission: "company:read",
        }}
        replace
      />
    );
  }

  return <CompanyListing />;
}
